$.ajaxSetup({
    beforeSend: function(xhr) {
        if (typeof overrideEcommStoreId !== 'undefined' && overrideEcommStoreId !== null) {
            xhr.setRequestHeader('x-storeId', overrideEcommStoreId);
        }
    }
});